export default __webpack_public_path__ + "static/media/logo_opalrt_square.e6858691.svg";